import { Controller } from "@hotwired/stimulus"

// Copies the value of the source target and briefly confirms it on the button. Without
// clipboard access, such as on a plain HTTP host, it leaves the value selected and
// shows the status target so the user can copy it by hand.
//
//   <div data-controller="clipboard">
//     <input data-clipboard-target="source" value="..." readonly>
//     <button data-action="clipboard#copy" data-clipboard-target="button">Copy</button>
//     <p data-clipboard-target="status" hidden>Press Ctrl+C to copy</p>
//   </div>
export default class extends Controller {
  static targets = ["source", "button", "status"]
  static values = { copiedLabel: String }

  async copy() {
    this.sourceTarget.focus()
    this.sourceTarget.select()

    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.confirmCopied()
    } catch {
      this.askToCopyManually()
    }
  }

  confirmCopied() {
    if (this.hasButtonTarget && this.copiedLabelValue) {
      const label = this.buttonTarget.textContent
      this.buttonTarget.textContent = this.copiedLabelValue
      setTimeout(() => { this.buttonTarget.textContent = label }, 2000)
    }
  }

  askToCopyManually() {
    this.sourceTarget.focus()
    this.sourceTarget.select()
    if (this.hasStatusTarget) this.statusTarget.hidden = false
  }
}
